import { Box, Typography } from "@mui/joy";

export default function ColorSideWidget() {
    return (
        <Box width={300}>
            <Typography>Selected Color</Typography>
        </Box>
    );
}
